module.exports = __webpack_public_path__ + "static/LogoUPB-54830402a0e799467e614be1d7357d84.png";